export var IdProfilePicture;
(function (IdProfilePicture) {
    IdProfilePicture[IdProfilePicture["Default"] = 1] = "Default";
})(IdProfilePicture || (IdProfilePicture = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdProfilePicture.ts
// module id = 1143
// module chunks = 3